import { render, staticRenderFns } from "./menuFooterBotton.vue?vue&type=template&id=1759df06"
import script from "./menuFooterBotton.vue?vue&type=script&lang=js"
export * from "./menuFooterBotton.vue?vue&type=script&lang=js"
import style0 from "./menuFooterBotton.vue?vue&type=style&index=0&id=1759df06&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports